/**
 * Refresh Button Component
 * Botão para atualizar conteúdo da página
 */

import React from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import { logger } from '@/utils/logger';

interface RefreshButtonProps {
  onRefresh: () => void | Promise<void>;
  loading?: boolean;
  tooltipTitle?: string;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({
  onRefresh,
  loading = false,
  tooltipTitle = 'Atualizar dados'
}) => {
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await onRefresh();
    } catch (error) {
      logger.error('Error refreshing:', error);
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <Tooltip title={tooltipTitle} arrow>
      <IconButton
        onClick={handleRefresh}
        disabled={loading || isRefreshing}
        color="inherit"
        sx={{
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.06)'
          },
          mr: 2
        }}
      >
        {loading || isRefreshing ? <CircularProgress size={24} color="inherit" /> : <Refresh />}
      </IconButton>
    </Tooltip>
  );
};

export default RefreshButton;
